import client from '../../providers/fetchClient'

export const login = data => client.post('/v3/users/login', data)

export const getCurrentUser = () => client.get('/v3/me')

export const forgetPassword = data => client.post('/v3/users/forget', data)

export const resetPassword = data => client.post('/v3/users/reset', data)
